export default {
  'menu.workbench': '工作台',
  'menu.activity': '活动中心',
  'menu.activityDetail': '活动详情',
  'menu.lead': '线索',
  'menu.leadDetail': '线索详情',
  'menu.enterpriseContact': '企业与联系人',
  'menu.enterpriseContact.enterprise': '企业',
  'menu.enterpriseContact.contact': '联系人',
  'menu.enterprise': '企业',
  'menu.contact': '联系人',
  'menu.enterpriseDetail': '企业详情',
  'menu.contactDetail': '联系人详情',
  'menu.investmentProject': '招商项目',
  'menu.investmentProjectDetail': '招商项目详情',
  'menu.industryResource': '产业资源',
  'menu.industryResource.industry': '产业图谱',
  'menu.industryResource.carrier': '载体与空间',
  'menu.industryResource.policyFund': '政策与资金',
  'menu.industryResource.cooperationResource': '合作资源',
  'menu.industry': '产业图谱',
  'menu.carrier': '载体与空间',
  'menu.policyFund': '政策与资金',
  'menu.cooperationResource': '合作资源',
  'menu.industryDetail': '产业链环节详情',
  'menu.carrierDetail': '载体详情',
  'menu.policyFundDetail': '政策与资金详情',
  'menu.cooperationResourceDetail': '合作资源详情',
  'menu.landingProject': '落地项目',
  'menu.landingProjectDetail': '落地项目详情',
  'menu.enterpriseService': '企业服务',
  'menu.enterpriseServiceDetail': '企业服务详情',
  'menu.settings.demoData': '演示数据',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.system': '系统管理',
  'menu.system.menu': '菜单管理',
  'menu.system.user': '用户管理',
  'menu.system.role': '角色管理',
  'menu.settings': '系统设置',
  'menu.settings.permissions': '权限管理',
  'menu.login': '登录',
  'menu.dashboard': '数据看板',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.workbench': '回到工作台',
  'menu.account.tenantManagement': '企业管理',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
